import { List as ListType } from '@yleisradio/areena-types';
import * as React from 'react';
import { ComponentType, useCallback, useState } from 'react';
import { sanitizeHtmlId } from 'utils/ui-helpers';
import { ListLayoutProps } from '.';
import GridList from './GridList';
import { HeroList } from './HeroList';
import { HorizontalList } from './HorizontalList';
import styles from './List.module.scss';
import { VerticalList } from './VerticalList';
import { ListHeader } from './ListHeader';
import { NotificationComponent } from 'components/Notifications';

const ListLayout = (props: ListLayoutProps): React.ReactElement | null => {
  if (props.list.style?.size === 'extra-large') return <HeroList {...props} />;

  switch (props.list.style?.layout) {
    case 'vertical':
      return <VerticalList {...props} />;
    case 'grid':
      return <GridList {...props} />;
    default:
      return <HorizontalList {...props} />;
  }
};

interface ListProps {
  list: ListType;
  listKey: string;
  index: number;
  notificationComponent?: ComponentType<NotificationComponent>;
}

export const List: React.FunctionComponent<ListProps> = ({
  list,
  listKey,
  index,
  notificationComponent,
}) => {
  const [isHidden, setHiddenState] = useState(false);
  const hideList = useCallback(() => setHiddenState(true), []);

  const title = list.title && list.title.trim();
  const titleId = title ? sanitizeHtmlId(`${listKey}-title`) : undefined;

  if (isHidden) return null;

  return (
    <section
      className={styles.list}
      aria-labelledby={titleId}
      data-testid="list"
    >
      <ListHeader
        title={title}
        titleElementId={titleId}
        controls={list.controls}
      />
      {ListLayout({
        hideList,
        index,
        list,
        listKey,
        notificationComponent,
      })}
    </section>
  );
};
